<template>
  <div class="container">
    <div class="row">
      <ul class="icons">
        <li><i class="fab fa-js"></i></li>
        <li><i class="fab fa-react"></i></li>
        <li><i class="fab fa-vue"></i></li>
        <li><i class="fas fa-file-code"></i></li>
        <li><i class="fab fa-css3-alt"></i></li>
        <li><i class="fab fa-node"></i></li>
        <li><i class="fab fa-github"></i></li>
        <li><i class="fas fa-server"></i></li>
        <li><i class="fas fa-code-branch"></i></li>
        <li><i class="fas fa-cloud-upload-alt"></i></li>
        <li><i class="fas fa-database"></i></li>
      </ul>
      <div class="col s6">
        <img src="../assets/shiri_face2.svg" width="400px" alt="" /><br />
      </div>
      <div class="col s6">
        <h2>
          Trust me,<br />
          I am a <small>(newb)</small> programmer.
        </h2>
        <h4>
          Creative, responsible, and proactive Web Developer with a strong academic background. Comfortable with a variety of technologies, and keen to learn and master new ones.
        </h4>
      </div>
    </div>
    <hr />
    <h4 class="center">
      Keeping the coding dream alive
    </h4>
  </div>
</template>

<script>
export default {
  name: "about",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  color: #fff;
}
</style>
